import React from 'react';
import styled from '@emotion/styled';
import cx from 'classnames';
import { RichText } from '@vimily/bonjoro-ui-components-v2/RichTextEditor';
import { RichTextViewer } from '@vimily/bonjoro-ui-components-v2/RichTextViewer';

import PoweredByBonjoroBadge, {
  PoweredByBonjoroBadgeProps,
} from './PoweredByBonjoroBadge';
import { useFeatures } from '~/react-hooks/use-features';

const Container = styled.div`
  box-shadow: 0 1px 10px 0 rgb(0 0 0 / 10%);
`;

export interface OutroMessageProps
  extends Pick<PoweredByBonjoroBadgeProps, 'onButtonClick'> {
  className?: string;
  message: RichText;
  logoUrl?: string;
  bgColor?: string;
  fontColor?: string;
  fontFamily?: string;
}

export default function OutroMessage({
  className = '',
  message,
  onButtonClick,
  logoUrl = '',
  bgColor,
  fontColor,
  fontFamily,
}: OutroMessageProps) {
  const { shouldHideBonjoroTestimonialBranding } = useFeatures();
  const defaultClassName = [
    'w-full h-full md:h-fit py-5 px-10 m-auto justify-center',
    'overflow-auto md:rounded-2xl',
    'flex flex-col items-center',
    'gap-y-8',
  ].join(' ');

  return (
    <Container
      className={cx(defaultClassName, className, {
        'justify-between': !shouldHideBonjoroTestimonialBranding,
      })}
      style={{backgroundColor: bgColor}}
    >
      {logoUrl && (
        <div className='md:!hidden mt-16 w-full flex justify-center'>
          <img
            src={logoUrl}
            width={125}
            height={25}
            className='object-contain'
          />
        </div>
      )}
      <div className='text-center text-xl text-neutral-600 md:p-10 md:my-auto'>
        <RichTextViewer value={message} style={{color: fontColor, fontFamily}}/>
      </div>
      {!shouldHideBonjoroTestimonialBranding && (
        <PoweredByBonjoroBadge onButtonClick={onButtonClick} />
      )}
    </Container>
  );
}
